// Mock Data für Dion Hair Clinic - DHI Ohne Rasur Landing Page

export const variant = "dhi";
export const variantLabel = "DHI Ohne Rasur";

export const clinicInfo = {
  name: "Dion Hair Clinic",
  tagline: "Haartransplantation ohne Rasur - DHI Methode",
  phone: "+49 2161 2963017",
  email: "info@dionhairclinic.de",
  website: "www.dionhairclinic.de",
  address: {
    street: "Schürenweg 61",
    city: "41063 Mönchengladbach",
    country: "Deutschland"
  },
  openingHours: {
    weekdays: "Mo - Fr: 9:00 - 18:00 Uhr",
    saturday: "Sa: 10:00 - 14:00 Uhr",
    sunday: "So: Geschlossen"
  }
};

export const heroContent = {
  title: "Haartransplantation",
  subtitle: "Ohne Rasur",
  description: "Mit der innovativen DHI-Technik transplantieren wir Ihre Haare ohne sichtbare Rasur. Perfekt für alle, die diskret und ohne Ausfallzeit ihr Haar verdichten möchten.",
  ctaPrimary: "Kostenlose Beratung",
  ctaSecondary: "Kostenlose Beratung",
  badge: "DHI Methode - Ohne Rasur"
};

export const stats = [
  { value: "3.000+", label: "DHI Behandlungen" },
  { value: "100%", label: "Ohne Rasur" },
  { value: "99%", label: "Zufriedene Patienten" },
  { value: "4.9★", label: "Google Bewertung" }
];

export const beforeAfterImages = [
  {
    id: 1,
    before: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&auto=format",
    after: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&auto=format",
    title: "DHI Patient 1",
    grafts: "2.500 Grafts",
    technique: "DHI Ohne Rasur"
  },
  {
    id: 2,
    before: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&auto=format",
    after: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop&auto=format",
    title: "DHI Patient 2",
    grafts: "3.000 Grafts",
    technique: "DHI Ohne Rasur"
  },
  {
    id: 3,
    before: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop&auto=format",
    after: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&auto=format",
    title: "DHI Patient 3",
    grafts: "2.200 Grafts",
    technique: "DHI Ohne Rasur"
  }
];

export const expertise = [
  {
    id: 1,
    icon: "Shield",
    title: "Modernste Technologie",
    description: "Wir verwenden die neueste Saphir DHI Hybridtechnik mit Choi-Pen für maximale Präzision und natürliche Ergebnisse."
  },
  {
    id: 2,
    icon: "Award",
    title: "Erfahrene Spezialisten",
    description: "Unser Team hat über 5.000 erfolgreiche Behandlungen durchgeführt. Jede DHI-Transplantation wird von spezialisierten Chirurgen geleitet."
  },
  {
    id: 3,
    icon: "Heart",
    title: "95%+ Anwachsrate",
    description: "Durch die direkte Implantation mit dem Choi-Pen sind die Grafts kürzer außerhalb des Körpers — das erhöht die Überlebensrate."
  },
  {
    id: 4,
    icon: "Star",
    title: "Rundum-Betreuung",
    description: "Von der kostenlosen Erstberatung über die Behandlung bis zur 12-monatigen Nachsorge — wir begleiten Sie persönlich."
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Kostenlose Beratung",
    description: "Wir analysieren Ihre Haarsituation und besprechen, ob die DHI-Methode ohne Rasur für Sie geeignet ist.",
    icon: "MessageSquare"
  },
  {
    step: 2,
    title: "Individuelle Planung",
    description: "Wir planen die Haarlinie und die Verteilung der Grafts, um ein natürliches Ergebnis zu erzielen.",
    icon: "Sparkles"
  },
  {
    step: 3,
    title: "DHI Behandlung",
    description: "Mit dem Choi-Pen werden die Haarfollikel einzeln entnommen und direkt implantiert - ohne Rasur.",
    icon: "Stethoscope"
  },
  {
    step: 4,
    title: "Sofort Alltagstauglich",
    description: "Sie können die Klinik verlassen und direkt wieder Ihrem Alltag nachgehen. Keine sichtbaren Spuren.",
    icon: "HeartHandshake"
  },
  {
    step: 5,
    title: "Natürliches Ergebnis",
    description: "Nach 12-18 Monaten genießen Sie volleres Haar - ohne dass jemand weiß, dass Sie eine Transplantation hatten.",
    icon: "Trophy"
  }
];

export const pricing = [
  {
    id: 1,
    name: "DHI Kompakt",
    subtitle: "Ideal für Geheimratsecken & kleine Verdichtungen",
    features: [
      "DHI Methode ohne Rasur",
      "Bis zu 1.500 Grafts",
      "Schmerzfreie Betäubung",
      "Nachsorgekit inklusive",
      "12 Monate Nachbetreuung"
    ],
    price: "3.999",
    popular: false,
    isDHIPricing: true
  },
  {
    id: 2,
    name: "DHI Standard",
    subtitle: "Unser beliebtestes Paket",
    features: [
      "DHI Methode ohne Rasur",
      "Bis zu 2.500 Grafts",
      "Schmerzfreie Betäubung (DPI)",
      "Premium Nachsorgekit",
      "18 Monate Nachbetreuung",
      "2 Regenerative Haartherapien"
    ],
    price: "5.499",
    popular: true,
    isDHIPricing: true
  },
  {
    id: 3,
    name: "DHI Premium",
    subtitle: "Maximale Diskretion & Komfort",
    features: [
      "DHI Methode ohne Rasur",
      "Bis zu 3.500 Grafts",
      "Schmerzfreie Betäubung (DPI)",
      "VIP Nachsorgekit",
      "24 Monate Nachbetreuung",
      "4 Regenerative Haartherapien",
      "Hotelübernachtung inklusive"
    ],
    price: "7.499",
    popular: false,
    isDHIPricing: true
  }
];

export const team = [
  {
    id: 1,
    name: "Dr. Sotirios Tsomkopoulos",
    role: "Facharzt für Thoraxchirurgie & Haartransplantationschirurg",
    video: "https://customer-assets.emergentagent.com/job_themeswitch-2/artifacts/wmewma40_video%285%29.mp4",
    image: "https://customer-assets.emergentagent.com/job_5a750e2c-9afa-457e-8878-f20f1025e07d/artifacts/x1tzbzpk_sortiris.jpeg",
    description: "Dr. Tsomkopoulos ist Facharzt für Thoraxchirurgie mit Approbation in Deutschland und der Schweiz. Er verfügt über langjährige Erfahrung als leitender Haartransplantationschirurg in renommierten Kliniken in Berlin, Basel und Thessaloniki.",
    specialization: "ISHRS-Mitglied, FUE & DHI Spezialist, Approbation DE/CH"
  },
  {
    id: 2,
    name: "Blerina Bevapi",
    role: "Fachärztin für Innere Medizin und Expertin für Haartransplantationen",
    video: "https://customer-assets.emergentagent.com/job_follicle-wizard/artifacts/if5w0ce2_bevapi.mp4",
    image: "/images/optimized/Blerina-Bevapi.webp",
    description: "Mit ihrer umfassenden medizinischen Expertise und spezialisiertem Wissen im Bereich Haartransplantationen sorgt Dr. Bevapi für höchste medizinische Standards und optimale Behandlungsergebnisse.",
    specialization: "Fachärztin für Innere Medizin, Spezialisierung auf Haartransplantationstechniken"
  },
  {
    id: 3,
    name: "Dilek Ergüney",
    role: "Medizinische Haartechnikerin",
    video: "https://customer-assets.emergentagent.com/job_follicle-wizard/artifacts/i3r32fur_ergueney.mp4",
    image: "/images/optimized/Dilek-Ergueney.webp",
    description: "Dilek Ergüney bringt umfangreiche Erfahrung in der präzisen Durchführung von Haartransplantationstechniken mit und ist spezialisiert auf die sorgfältige Handhabung von Haarfollikeln für optimale Ergebnisse.",
    specialization: "Zertifizierte medizinische Haartechnikerin mit Spezialisierung auf FUE- und DHI-Techniken"
  },
  {
    id: 4,
    name: "Songül Bulut",
    role: "Spezialistin für Haartransplantationen",
    video: "https://customer-assets.emergentagent.com/job_follicle-wizard/artifacts/mvg2maej_bulut.mp4",
    image: "/images/optimized/Songuel-Bulut.webp",
    description: "Songül Bulut absolvierte ihr Medizinstudium in der Türkei und sammelte jahrelange Erfahrung in führenden Haarkliniken weltweit. Ihre internationale Expertise garantiert erstklassige Behandlungsergebnisse.",
    specialization: "Medizinstudium in der Türkei, internationale Erfahrung in führenden Haarkliniken"
  }
];

export const clinicImages = [
  {
    id: 1,
    src: "/images/optimized/DionHairClinic_Eingang.webp",
    alt: "Klinik Eingang",
    title: "Unsere Klinik"
  },
  {
    id: 2,
    src: "/images/optimized/DionHairClinic_Flur.webp",
    alt: "Klinik Flur",
    title: "Moderner Flur"
  },
  {
    id: 3,
    src: "/images/optimized/DionHairClinic_OP_Raum.webp",
    alt: "OP Raum",
    title: "Steriler OP-Raum"
  },
  {
    id: 4,
    src: "/images/optimized/DionHairClinic_Wartebereich.webp",
    alt: "Wartebereich",
    title: "Eleganter Wartebereich"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Christian L.",
    location: "Frankfurt",
    rating: 5,
    text: "Die DHI-Methode ohne Rasur war perfekt für mich. Ich konnte am Montag direkt wieder ins Büro - niemand hat etwas bemerkt!",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&auto=format",
    treatment: "DHI Ohne Rasur, 2.000 Grafts"
  },
  {
    id: 2,
    name: "Thomas R.",
    location: "Stuttgart",
    rating: 5,
    text: "Als Geschäftsführer konnte ich mir keine lange Ausfallzeit leisten. Mit DHI ohne Rasur war das kein Problem.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&auto=format",
    treatment: "DHI Ohne Rasur, 2.500 Grafts"
  },
  {
    id: 3,
    name: "Michael P.",
    location: "Düsseldorf",
    rating: 5,
    text: "Diskret, professionell und das Ergebnis ist fantastisch. Die DHI-Technik ist jeden Cent wert.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&auto=format",
    treatment: "DHI Ohne Rasur, 1.800 Grafts"
  }
];

export const faqItems = [
  {
    question: "Was bedeutet DHI ohne Rasur?",
    answer: "Bei der DHI-Methode (Direct Hair Implantation) werden die Haarfollikel einzeln entnommen und direkt mit einem Choi-Pen implantiert. Anders als bei der klassischen FUE-Methode ist keine Rasur des Kopfes erforderlich."
  },
  {
    question: "Was ist die Saphir DHI Hybridmethode?",
    answer: "Die Saphir DHI Hybridmethode kombiniert das Beste aus zwei Welten: Die Saphir-Klingen ermöglichen feinere Kanalöffnungen mit schnellerer Heilung, während die DHI-Technik mit dem Choi-Pen eine direkte, präzise Implantation ohne Rasur erlaubt. Das Ergebnis: maximale Haardichte, natürlichste Wuchsrichtung und kürzeste Heilungszeit."
  },
  {
    question: "Für wen ist DHI ohne Rasur geeignet?",
    answer: "Die Methode ist ideal für Patienten, die diskret bleiben möchten, lange Haare haben oder keine Ausfallzeit möchten. Besonders beliebt bei Geschäftsleuten, Frauen mit dünnem Haar und Patienten, die eine gezielte Verdichtung wünschen."
  },
  {
    question: "Muss wirklich gar nicht rasiert werden?",
    answer: "Richtig! Bei der DHI-Methode wird weder im Spender- noch im Empfängerbereich rasiert. Ihr bestehendes Deckhaar bleibt vollständig erhalten. Die transplantierten Haare wachsen zwischen dem bestehenden Haar und sind sofort nach der Behandlung von außen nicht sichtbar."
  },
  {
    question: "Ist DHI ohne Rasur teurer als Standard-FUE?",
    answer: "Ja, die DHI-Methode erfordert mehr Zeit, spezielle Instrumente und höhere Expertise. Dafür erhalten Sie maximale Diskretion, können sofort wieder Ihrem Alltag nachgehen und profitieren von einer höheren Haardichte pro Quadratzentimeter."
  },
  {
    question: "Wie viele Grafts können ohne Rasur transplantiert werden?",
    answer: "In einer Sitzung können wir ohne Rasur typischerweise bis zu 3.000–3.500 Grafts transplantieren. Für größere Mengen empfehlen wir mehrere Sitzungen oder eine Kombination mit der Saphir DHI Hybridmethode."
  },
  {
    question: "Ist die Anwachsrate bei DHI genauso hoch?",
    answer: "Ja, sogar oft höher! Da die Grafts direkt implantiert werden, sind sie kürzer außerhalb des Körpers, was die Überlebensrate erhöht. Bei der Saphir DHI Hybridmethode wird dies durch die feineren Kanalöffnungen zusätzlich begünstigt."
  },
  {
    question: "Wie schnell bin ich wieder gesellschaftsfähig?",
    answer: "Das ist der größte Vorteil der DHI-Methode: Da keine sichtbare Rasur erfolgt, sind Sie sofort wieder gesellschaftsfähig. Die meisten Patienten gehen am nächsten Tag wieder arbeiten. Leichte Rötungen sind unter dem bestehenden Haar nicht sichtbar."
  },
  {
    question: "Wo befindet sich Ihre Klinik?",
    answer: "Unsere Klinik befindet sich in Mönchengladbach (Schürenweg 61) und ist ideal erreichbar aus Köln, Düsseldorf, dem Ruhrgebiet und den Niederlanden."
  }
];

export const features = {
  showAIAnalysis: true,
  analysisType: "hair",
  showPricing: true,
  showBeforeAfter: true,
  showTeam: true,
  showClinic: true,
  showHairGrowthTimeline: false,
  showDhiProcess: false,
  showDhiComparison: false,
  showDhiTargetAudience: true,
  showDhiQuickFacts: true,
  showDhiHybridOnly: true
};
